window.$ = window.jQuery = require('jquery')
window.Cookies = require('js-cookie')

require('jquery-ujs')
require('jquery-fancybox/lib/jquery.mousewheel-3.0.6.pack')
require('jquery-fancybox/source/js/jquery.fancybox.pack')
require('bootstrap-sass/assets/javascripts/bootstrap/alert')
require('bootstrap-sass/assets/javascripts/bootstrap/modal')
require('bootstrap-sass/assets/javascripts/bootstrap/dropdown')
require('./public/public')
require('./public/conversion.goals')
